<script setup lang="ts">
import { onMounted, ref } from "vue";
import { RouterLink, useRouter } from "vue-router";

import SkoreSpinner from "@/components/ui/SkoreSpinner.vue";
import FullPageCenteredLayout from "@/layouts/FullPageCenteredLayout.vue";
import { RouteNames } from "@/router";
import { useAuthStore } from "@/stores/auth";

const router = useRouter();
const authStore = useAuthStore();
const hasError = ref(false);

onMounted(async () => {
  // USE native parsing because route.query is empty if there is a fragment in the URL
  const parsedUrl = URL.parse(document.baseURI);
  if (parsedUrl) {
    const params = parsedUrl.searchParams;
    const access_token = params.get("access_token");
    const refresh_token = params.get("refresh_token");
    const expires_at = params.get("expires_at");
    const next = params.get("next");
    if (access_token && refresh_token && expires_at) {
      // save the tokens and initialize tracking
      await authStore.handleLoginSuccess(
        access_token as string,
        refresh_token as string,
        expires_at as string
      );
      if (next && !next.includes(RouteNames.Logout)) {
        router.replace({ path: next as string });
      } else {
        router.replace({ name: RouteNames.Dispatch });
      }
    }
  }

  // something went wrong notify the user
  hasError.value = true;
});
</script>

<template>
  <FullPageCenteredLayout>
    <main class="login-success">
      <div class="error" v-if="hasError">
        <div class="message">Something went wrong, please try again.</div>
        <div class="link">
          <RouterLink :to="{ name: RouteNames.Login }">login</RouterLink>
        </div>
      </div>
      <SkoreSpinner v-else />
    </main>
  </FullPageCenteredLayout>
</template>

<style scoped>
.login-success {
  .error {
    .message {
      color: var(--content-negative);
    }

    .link {
      a {
        color: var(--content-primary);
      }
    }
  }
}
</style>
